import React from "react";
import Tooltips, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltips {...props} classes={{ popper: className }} />
))(() => ({
  // styled() emits plain CSS, so var() is fine here (unlike the MUI palette).
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "var(--color-ui-surface-raised)",
    color: "var(--color-ui-text)",
    border: "1px solid var(--color-ui-border)",
    fontSize: 11,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "var(--color-ui-surface-raised)",
  },
}));
const Tooltip = ({ children, title = "" }) => {
  return (
    <>
      <LightTooltip placement="top" arrow title={title}>
        {children}
      </LightTooltip>
    </>
  );
};

export default Tooltip;
